import { getSupabase, supabaseSchema } from "../components/supabaseClient";

// The signed-in user as the Navbar and the Messages host see them. Role and
// name come from the active client's users view (the per-tenant copy when
// browsing normally; the target's row during view-as). The schema is the
// first entry of public.users.schema, the canonical source (tenant copies
// can drift in the order of the comma list).
export async function loadCurrentStaffUser() {
  const supabase = await getSupabase();
  const { data: { session } } = await supabase.auth.getSession();
  const user = session?.user;
  if (!user) return null;
  let role = null;
  let name = null;
  const { data, error } = await supabase.from("users").select("role,name").eq("id", user.id).single();
  if (data) {
    role = data.role;
    name = data.name;
  } else if (error) {
    console.log("Error fetching user data:", error.message);
  }
  let schema = supabaseSchema || "public";
  try {
    const { data: pubRow } = await supabase.schema("public").from("users").select("schema").eq("id", user.id).single();
    const raw = pubRow?.schema || "";
    const active = raw.includes(",") ? raw.split(",")[0].trim() : raw.trim();
    schema = active || supabaseSchema || "public";
  } catch (_) {
    // keep the fallback
  }
  return { id: user.id, email: user.email, name, role, schema };
}
